import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getProjectReportDetails(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETPROJECTREPORT}?start_date=${payload.startDate}&end_date=${payload.endDate}&projectId=${payload.projectId}&page=${payload.pageNumber}&limit=${payload.pageSize}&search=${payload.search}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

/** One call only — show whatever comes back, no extra pages. */
export async function getProjectsForFilter() {
  const callParams = await getCallParams("GET");
  return makeCall(
    `${urls.GETPROJECTLIST}?page=0&limit=25&search=`,
    callParams
  );
}
